import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=1099228a&scoped=true&lang=pug"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"
import style0 from "./IconLink.vue?vue&type=style&index=0&id=1099228a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1099228a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1099228a')) {
      api.createRecord('1099228a', component.options)
    } else {
      api.reload('1099228a', component.options)
    }
    module.hot.accept("./IconLink.vue?vue&type=template&id=1099228a&scoped=true&lang=pug", function () {
      api.rerender('1099228a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/IconLink.vue"
export default component.exports